<template>
  <div>
    <PageLoader v-bind:storage="appLoading" v-bind:contain="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#3ea56e" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-dialog v-model="shippedDialog" width="450">
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 18px;
              "
            >
              Enter Shipment Details
            </span>
          </v-flex>
          <v-flex xs12 pt-4>
            <v-text-field
              v-model="shippedService"
              label="Shipped Service (Optional)"
              outlined
              dense
              color="#FF1313"
              hide-details
              class="mb-4"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              v-model="trackingId"
              label="Tracking ID (Optional)"
              outlined
              dense
              color="#FF1313"
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs6 px-2 pt-4>
            <v-btn
              tile
              block
              depressed
              dark
              color="#1BD93B"
              @click="confirmShipped"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                Confirm
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs6 px-2 pt-4>
            <v-btn
              tile
              block
              depressed
              dark
              color="#ff1313"
              @click="cancelShipped"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                Cancel
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cancelDialog" width="400">
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 18px;
              "
            >
              Do you want to cancel this product ?
            </span>
          </v-flex>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 14px;
              "
            >
              {{ storage.productname }}
            </span>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#ff1313"
              @click="cancelProduct"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                Yes
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#1BD93B"
              @click="cancelDialog = false"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                No
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <v-layout wrap justify-center>
      <v-flex xs12>
        <v-layout wrap justify-start>
          <v-flex xs12 sm2 pr-1 py-1>
            <v-img
              :src="baseURL + 'u/' + storage.productId.photos[0]"
              height="100px"
              contain
            >
              <template v-slot:placeholder> <ImageLoader /> </template>
            </v-img>
          </v-flex>
          <v-flex xs12 sm10>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <router-link :to="'/Seller/Product/' + storage.productId._id">
                  <span
                    style="
                      font-family: poppinslight;
                      font-size: 15px;
                      color: #000000;
                    "
                  >
                    {{ storage.productId.productname }}
                  </span>
                </router-link>
              </v-flex>
              <v-flex xs12 text-left pt-2>
                <v-layout wrap justify-space-between>
                  <v-flex xs2>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Quantity
                        </span>
                      </v-flex>
                      <v-flex
                        xs12
                        text-left
                        v-if="storage.quantity || storage.unit"
                      >
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 18px;
                            color: #000000;
                          "
                        >
                          {{ storage.quantity }} {{ storage.unit }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Price
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 18px;
                            color: #000000;
                          "
                        >
                          {{ storage.price }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Offer Price
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 18px;
                            color: #000000;
                          "
                        >
                          {{ storage.offerPrice }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs1>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Offer
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 18px;
                            color: #000000;
                            white-space: nowrap;
                          "
                        >
                          {{ storage.offer }} %
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 v-if="storage.totalPackingCharge">
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Packing Charge
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 18px;
                            color: #000000;
                          "
                        >
                          {{ storage.totalPackingCharge }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Total Amount
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 18px;
                            color: #000000;
                          "
                        >
                          {{ storage.TotalAmount }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <!-- <v-flex xs2>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Size
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 18px;
                            color: #000000;
                          "
                        >
                          {{ storage.size }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2>
                    <v-layout wrap justify-center>
                      <v-flex xs12 text-left>
                        <span
                          style="
                            font-family: opensanssemibold;
                            font-size: 14px;
                            color: #8d8d8d;
                          "
                        >
                          Color
                        </span>
                      </v-flex>
                      <v-flex xs12 text-left>
                        <v-avatar :color="storage.color" size="25" />
                      </v-flex>
                    </v-layout>
                  </v-flex> -->
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 py-2 py-lg-0>
            <v-layout wrap justify-end>
              <!-- <v-flex
                xs6
                sm4
                md4
                lg3
                px-2
                v-if="
                  storage.orderStatus != 'Cancelled' &&
                  storage.orderStatus != 'Delivered' &&
                  order.purchasetype == 'Normal'
                "
              >
                <v-btn
                  :ripple="false"
                  depressed
                  dark
                  block
                  tile
                  color="#FF1313"
                  @click="cancelDialog = true"
                >
                  Cancel
                </v-btn>
              </v-flex> -->
              <v-flex text-center v-if="storage.isPromoCodeApplied">
                &nbsp;
                <v-icon color="green"> mdi-sale</v-icon>
                <span
                  style="font-family: poppinslight;
                      font-size: 14px;
                      color: #000000;"
                >
                  Promo Code Applied &nbsp;
                </span>
                <span>
                  <v-btn small depressed color="green" tile :ripple="false">
                    <span
                      style="color:white; font-family: opensanssemibold;
                            font-size: 13px"
                    >
                      {{ storage.promoCodeDetails.promoCode }}</span
                    >
                  </v-btn>
                </span>
              </v-flex>
              <v-flex xs6 sm4 md4 lg4 px-2>
                <v-select
                  outlined
                  dense
                  color="#FF1313"
                  placeholder="Order Status"
                  v-model="orderStatus"
                  :items="orderStatuses"
                  item-text="name"
                  item-value="value"
                  item-color="#FF1313"
                  hide-details
                  v-on:input="changeStatus"
                  item-disabled="disabled"
                >
                  <template v-slot:item="{ item }">
                    <span class="text-left">
                      {{ item.name }}
                    </span>
                  </template>
                </v-select>
                <div
                  v-if="storage.shippedService || storage.trackingId"
                  style="padding-top: 8px; text-align: left"
                >
                  <div
                    v-if="storage.shippedService"
                    style="
                      font-family: poppinslight;
                      font-size: 13px;
                      color: #8d8d8d;
                    "
                  >
                    Service:
                    <span
                      style="
                        color: #000000;
                        font-family: opensanssemibold;
                        font-size: 13px;
                      "
                    >
                      {{ storage.shippedService }}
                    </span>
                  </div>
                  <div
                    v-if="storage.trackingId"
                    style="
                      font-family: poppinslight;
                      font-size: 13px;
                      color: #8d8d8d;
                    "
                  >
                    Tracking ID:
                    <span
                      style="
                        color: #000000;
                        font-family: opensanssemibold;
                        font-size: 13px;
                      "
                    >
                      {{ storage.trackingId }}
                    </span>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage", "order"],
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      orderStatus: "Placed",
      orderStatuses: [
        { name: "Pending", value: "Pending" },
        { name: "Order Confirmed", value: "Order Confirmed" },
        { name: "Cancelled", value: "Cancelled", disabled: true },
        { name: "Cancelled By Seller", value: "Cancelled By Seller" },
        { name: "Shipped", value: "Shipped" },
        { name: "Out For Delivery", value: "Out For Delivery" },
        { name: "Delivered", value: "Delivered" },
        // { name: "Return", value: "Return" },
      ],
      cancelDialog: false,
      shippedDialog: false,
      shippedService: "",
      trackingId: "",
    };
  },
  beforeMount() {
    this.orderStatus = this.storage.orderStatus;
  },
  methods: {
    cancelProduct() {
      this.$emit("stepper", {
        type: "cancell",
        product: this.storage,
        transactionid: this.order._id,
      });
      this.cancelDialog = false;
    },
    confirmShipped() {
      this.shippedDialog = false;
      this.updateStatus();
    },
    cancelShipped() {
      this.orderStatus = this.storage.orderStatus;
      this.shippedDialog = false;
    },
    changeStatus() {
      if (this.orderStatus === "Shipped") {
        this.shippedDialog = true;
      } else {
        this.updateStatus();
      }
    },
    updateStatus() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/seller/ordered/item/status/change",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          itemId: this.storage._id,
          orderId: this.storage.orderId,
          orderStatus: this.orderStatus,
          shippedService: this.shippedService,
          trackingId: this.trackingId,
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            this.storage.orderStatus = this.orderStatus;
            this.storage.deliverystatus = this.orderStatus;
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.shippedService = "";
            this.trackingId = "";
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showSnackBar = true;
            this.orderStatus = this.storage.orderStatus;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          this.orderStatus = this.storage.orderStatus;
          console.log(err);
        });
    },
  },
};
</script>
